export default __webpack_public_path__ + "static/media/analisis.6de223b0.png";